/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmTypDokumentu extends GContentBase<SeznamAdmTypDokumentuObj> {
        private seznamObj: SeznamAdmTypDokumentuObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmTypDokumentuObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmTypDokumentuNew",
                contentCaption: "jres:33000107",
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_typ}"
                },
                gridSettings: {
                    columnOrder: "nazev,poznamka,popis,lhuta_vyr,ktg_typ_txt,st_utaj_id_txt,aktivita_ssl,ofic_nazev,spis_pl,spis_znak,skar_znak,skar_lhuta,nazev_ulz,s_gen_cj,typ_ag,typ_ag_txt,ico"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmTypDokumentuObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmTypDokumentu", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmTypDokumentu",
                newRecord: isNew,
                ixs_typ: isNew == true ? null : data.ixs_typ
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                "actOpenDetail*",
                "actNewDetail*",
                "actAddToComparison*",
                "actOpenDialogVyberovaSkupina*",
                {
                    type: "static", caption: "jres:33000415", icon: "fa-expand", favorite: true, children: [ //RC 33000415 : Vlastnosti
                        {
                            action: this.cnt.actions.actOpenSeznamAdmVlastnostTypObjektu
                        },
                        {
                            action: this.cnt.actions.actOpenSeznamAdmVlastnostObecnyObjekt
                        },
                        {
                            action: this.cnt.actions.actOpenBaseDialogHromadneVlastnosti
                        }
                    ]
                }
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenDialogVyberovaSkupina*"])
        }

        createFilterForm() {

        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmTypDokumentu.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.ixs_typ),
                nazev: data["nazev"]
            }
        }
    }
}